import { ResourceType } from "@evergis/api";
import { IconTypesKeys } from "@evergis/ui";

export type CopyPublicResourceLinkProps = {
  name: string;
  resourceType: ResourceType;
  isPublicRole: boolean;
};

export type SocialItem = {
  icon: IconTypesKeys;
  shareLink: string;
};

export enum ResourceLinkType {
  WMS = "wms",
  WFS = "wfs",
  Public = "shared",
  Developers = "dev",
}
